<template>
  <el-table-column
    prop="payment_method"
    sortable="custom"
    label="Fizetési mód"
    show-overflow-tooltip
    min-width="130"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.payment_method === 'cash'" size="small" type="success">
        <i class="el-icon-coin"></i> Készpénz
      </el-tag>
      <el-tag v-if="scope.row.payment_method === 'transfer'" size="small" type="primary">
        <i class="el-icon-bank-card"></i> Átutalás
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'payment_method',
  };
</script>
